import { render } from "./LastMags.vue?vue&type=template&id=c1afe17e&scoped=true"
import script from "./LastMags.vue?vue&type=script&lang=js"
export * from "./LastMags.vue?vue&type=script&lang=js"

import "./LastMags.vue?vue&type=style&index=0&id=c1afe17e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1afe17e"]])

export default __exports__